export default function Hero() {
  return (
    <section id="top" className="border-b border-background-200/70 bg-background-50">
      <div className="wrap grid items-center gap-10 py-12 md:py-16 lg:grid-cols-[1.1fr_0.9fr] lg:py-20">
        {/* 文字列 */}
        <div className="relative">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <span className="inline-flex h-2 w-2 rounded-full bg-accent-500" />
            吃瓜91 · 释义向数字梗 · 民间说法非官方定义
          </div>

          <h2 className="eyebrow text-4xl font-black leading-tight text-foreground-950 md:text-5xl">
            看到「吃瓜<span className="text-primary-600">91</span>」，
            <br className="hidden md:block" />
            别再装作没看懂
          </h2>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700">
            这个数字看着眼熟，却总说不清来路。吃瓜是围观、91 谐音“就要”，
            连起来像一句“前排就位、等瓜开”的暗号。把含义、密码拆解、由来说法
            一次讲清，下次别人甩数字梗给你，你能直接带进去聊。
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <a
              href="#decode"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              看 91 数字解读
              <i className="ri-arrow-right-line h-4 w-4 flex items-center justify-center" />
            </a>
            <a
              href="#compare"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              各种说法对比
            </a>
          </div>

          <dl className="mt-9 flex flex-wrap gap-x-8 gap-y-3 border-t border-background-200 pt-5">
            {[
              ["站型", "含义解读"],
              ["语言", "中文语境"],
              ["定位", "轻松玩梗"],
            ].map(([k, v]) => (
              <div key={k} className="flex items-baseline gap-2">
                <dt className="text-xs text-foreground-500">{k}</dt>
                <dd className="eyebrow text-sm font-semibold text-foreground-900">{v}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 图列：对开海报 */}
        <div className="relative mx-auto w-full max-w-md lg:max-w-none">
          <div className="relative overflow-hidden rounded-lg border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20zine%20collage%20poster%20of%20a%20sliced%20watermelon%20with%20bold%20numbers%209%20and%201%20cut%20into%20the%20rind%2C%20retro%20magazine%20print%20graphics%2C%20graphic%20speech%20bubble%2C%20watermelon%20red%20and%20leaf%20green%20ink%20on%20warm%20cream%20paper%20background%2C%20high%20contrast%2C%20flat%20illustration%2C%20clean%20modern%20layout&width=900&height=1100&seq=chigua-cover-01&orientation=portrait"
              alt="吃瓜91 数字梗释义海报，西瓜与数字91拼贴"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-foreground-800">
              Vol.01 · 本期词条
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}